module.exports = __webpack_public_path__ + "img/yrd_gf.60844386.jpg";